import { getVisible, hide, jsx, show } from '@amzn/shiv'
import { ErrorOrigin, errorReporter } from '@amzn/vinyl-util'
import { ErrorMessage } from '@/components/ErrorMessage'

export function ErrorsView() {
    const messages = <div className="messages"></div>
    const view = (
        <div className="messageContainer">
            <button
                className="textButton"
                id="clearErrorsBtn"
                onclick={() => {
                    messages.innerHTML = ''
                    hide(view)
                }}
            >
                Clear Errors
            </button>
            {messages}
        </div>
    )
    hide(view)

    let previousMessage: string | null = null

    errorReporter.on('error', (event) => {
        // Filter out internal service errors - they're handled by NoConnectivityBanner
        if (event.origin === ErrorOrigin.SERVICE_INTERNAL) {
            return
        }
        // There may be multiple errors reported stemming from the same source, only show the first.
        const message = event.message ?? 'Unknown error'
        if (previousMessage === message && getVisible(view)) return
        previousMessage = message
        show(view)
        messages.append(
            ErrorMessage({
                message,
            })
        )
    })

    return view
}
